<form class="ui-form" [formGroup]="form">
  <app-form>
    <app-row>
      <app-field [label]="'Тип'">
        <p-dropdown [options]="types" formControlName="type" placeholder="Выберите тип компонента" />
      </app-field>

      <app-field [label]="'ID'">
        <input
          pInputText
          type="text"
          formControlName="id"
          placeholder="Введите id компонента"
          [class.loading]="loading"
        />
      </app-field>
    </app-row>

    <app-row>
      <app-field [label]="'Название'">
        <input
          pInputText
          type="text"
          formControlName="label"
          placeholder="Введите название поля"
          [class.loading]="loading"
        />
      </app-field>

      <app-field [label]="'Подсказка'">
        <input
          pInputText
          type="text"
          formControlName="placeholder"
          placeholder="Введите подсказку для поля"
          [class.loading]="loading"
        />
      </app-field>
    </app-row>

    <app-row>
      <app-field [label]="'Порядок'">
        <p-inputNumber formControlName="order" placeholder="Введите порядковый номер" [class.loading]="loading" />
      </app-field>

      <app-field [label]="'Видимость'">
        <p-inputSwitch formControlName="visible" [class.loading]="loading" />
      </app-field>
    </app-row>
  </app-form>
</form>
